import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { docSize } from '../utils/dom/document';
import { moveableClass } from './styles';
import { getUidStr } from '../utils/uid';
import { curry } from '../utils/func';
var DIS_LIMIT = 50;
export default curry(function (handler, Origin) {
  var _temp;

  return _temp =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Moveable, _React$Component);

    var _super = _createSuper2(Moveable);

    function Moveable(props) {
      var _this;

      _classCallCheck(this, Moveable);

      _this = _super.call(this, props);
      _this.moveabledId = void 0;
      _this.el = void 0;
      _this.handlerEl = void 0;
      _this.hasDragged = void 0;
      _this.handlerPos = void 0;
      _this.state = {
        x: 0,
        y: 0,
        draging: false
      };
      _this.moveabledId = getUidStr();
      _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
      _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_this));
      _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(Moveable, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.bindEvent();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.el) {
          this.el.removeEventListener('mousedown', this.handleMouseDown);
        }
      }
    }, {
      key: "getStyle",
      value: function getStyle() {
        var _this$state = this.state,
            x = _this$state.x,
            y = _this$state.y;
        if (!this.hasDragged) return undefined;
        return {
          transform: "translate(".concat(x, "px, ").concat(y, "px)")
        };
      }
    }, {
      key: "bindEvent",
      value: function bindEvent() {
        this.el = document.querySelector(".".concat(moveableClass(this.moveabledId)));
        if (!this.el) return;
        this.el.addEventListener('mousedown', this.handleMouseDown);
        this.handlerEl = handler ? this.el.querySelector(handler) || this.el : this.el;
      }
    }, {
      key: "handleMouseDown",
      value: function handleMouseDown(e) {
        if (e.button !== 0 || !this.el) return;
        if (handler && !e.target.matches(handler)) return;
        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('mouseup', this.handleMouseUp);
        document.addEventListener('mouseleave', this.handleMouseUp);

        if (!this.handlerPos) {
          this.handlerPos = this.handlerEl.getBoundingClientRect();
        }

        this.hasDragged = true;
        this.setState({
          draging: true
        });
      }
    }, {
      key: "handleMouseMove",
      value: function handleMouseMove(e) {
        var _this2 = this;

        this.setState(function (prev) {
          var x = prev.x + e.movementX;
          var y = prev.y + e.movementY;

          if (_this2.handlerPos.right + x < DIS_LIMIT || _this2.handlerPos.left + x > docSize.width - DIS_LIMIT) {
            // eslint-disable-next-line prefer-destructuring
            x = prev.x;
          }

          if (_this2.handlerPos.bottom + y < DIS_LIMIT || _this2.handlerPos.top + y > docSize.height - DIS_LIMIT) {
            // eslint-disable-next-line prefer-destructuring
            y = prev.y;
          }

          return {
            x: x,
            y: y
          };
        });
      }
    }, {
      key: "handleMouseUp",
      value: function handleMouseUp() {
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.handleMouseUp);
        document.removeEventListener('mouseleave', this.handleMouseUp);
        this.setState({
          draging: false
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            moveable = _this$props.moveable,
            others = _objectWithoutProperties(_this$props, ["moveable"]);

        if (!moveable) return (
          /*#__PURE__*/
          React.createElement(Origin, others)
        );
        var ms = Object.assign({}, this.props.style, this.getStyle());
        var mc = classnames(this.props.className, moveableClass('_', this.moveabledId, this.state.draging && 'draging'));
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, others, {
            style: ms,
            className: mc
          }))
        );
      }
    }]);

    return Moveable;
  }(React.Component), _temp;
});